import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronRightMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronRightMedium"><Path d="M9.5 18.5L16 12L9.5 5.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronRightMedium;
